import type { BetslipView } from '@nsftx/seven-client-sdk-integrator'

const LocalTicketStatus = {
  Accepted: 'ACCEPTED',
  Pending: 'PENDING',
  Failed: 'FAILED',
  Rejected: 'REJECTED'
} as const

type LocalTicketStatuses = (typeof LocalTicketStatus)[keyof typeof LocalTicketStatus]

const ClientTicketAction = {
  Add: 'add'
} as const

type ClientTicketActions = (typeof ClientTicketAction)[keyof typeof ClientTicketAction]
type ClientTicketActionType =
  'BETSLIP_PAYIN' | 'BETSLIP_PAYOUT' | 'BETSLIP_CANCEL' | 'BETSLIP_CASHOUT'

interface ClientTicketBet {
  id: string
}

interface ClientTicket {
  readonly feBetslipId: string
  readonly linkCode: string
  readonly gameName: string
  readonly actionType: ClientTicketActionType
  readonly timestamp: number
  localStatus: LocalTicketStatuses
  betslip?: BetslipView
  amount: number | null
  currency: string | null
  barcode: string | null
  bets: ClientTicketBet[] | null
}

export { LocalTicketStatus, ClientTicketAction }
export type { ClientTicket, ClientTicketActions, LocalTicketStatuses, ClientTicketActionType }
